import React, { ReactElement } from 'react';

interface Props {
  width?: string;
  height?: string;
}

const Trash = (props: Props): ReactElement => {
  const { width, height } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 19 22">
      <path d="M17.599,4.888l-16.342,0l0,-0.611c0,-0.336 0.283,-0.611 0.629,-0.611l15.084,0c0.346,0 0.629,0.275 0.629,0.613l0,0.609Zm-1.257,14.056c0,1.01 -0.846,1.832 -1.886,1.832l-10.056,0c-1.041,0 -1.886,-0.822 -1.886,-1.832l0,-12.833l13.828,0l0,12.833Zm-9.193,-17.722l4.557,0l0.539,1.223l-5.634,0l0.538,-1.223Zm11.707,3.055c0,-1.01 -0.846,-1.832 -1.886,-1.832l-3.356,0l-1.078,-2.445l-6.216,0l-1.078,2.445l-3.356,0c-1.041,0 -1.886,0.822 -1.886,1.832l0,1.835l1.257,0l0,12.833c0,1.683 1.41,3.055 3.143,3.055l10.056,0c1.733,0 3.143,-1.372 3.143,-3.055l0,-12.834l1.257,0l0,-1.834Zm-13.828,14.056l1.257,0l0,-9.779l-1.257,0l0,9.779Zm3.771,0l1.257,0l0,-9.779l-1.257,0l0,9.779Zm3.772,0l1.257,0l0,-9.779l-1.257,0l0,9.779Z" />
    </svg>
  );
};

Trash.defaultProps = {
  width: '100%',
  height: '100%',
};

export default Trash;
